import { render, staticRenderFns } from "./CRUDTable1.vue?vue&type=template&id=31e0b2e6"
import script from "./CRUDTable1.vue?vue&type=script&lang=js"
export * from "./CRUDTable1.vue?vue&type=script&lang=js"
import style0 from "./CRUDTable1.vue?vue&type=style&index=0&id=31e0b2e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports